import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import {
  service_add_action,
  service_detail_action,
} from "../../../actions/master_actions/service_action";
import Loader from "../../../utils/Loader";
import Header from "../../../common_components/Header";
import { sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";

class ServicesAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOpen: false,
      servicesData: [],
      userId: "",
      AdditionalServicesID: "",
      Code: "",
      Name: "",
      PricingOn: "",
      HSNCode: "",
      GST: "",
      StatusID: "",
      ServiceAccount: "",
      Description: "",
       // input validate
       serviceNameErr: '',
       PricingOnErr: '',
       HSCCodeErr: '',
       GSTErr: '',
      
    };
    this.clearFields = this.clearFields.bind(this);
    this.serviceDetails = this.serviceDetails.bind(this);
    this.navigateBackService = this.navigateBackService.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    const AdditionalServicesID =
      this.props.location.state?.AdditionalServicesID || "";
    if (AdditionalServicesID) {
      this.setState({ AdditionalServicesID }, () => {
        this.serviceDetails();
      });
    } else {
      this.clearFields();
    }
  }
  navigateBackService() {
    this.props.navigate("/additional_service");
  }
  clearFields() {
    this.setState({
      AdditionalServicesID: "",
      Code: "",
      Name: "",
      PricingOn: "",
      HSNCode: "",
      GST: "",
      Status: "",
      ServiceAccount: "",
      Description: "",
    });
  }
  inputValidate() {
    const { Name,PricingOn,HSNCode,GST } = this.state

    if (PricingOn == "" || PricingOn == null || PricingOn == 'Select') {
        this.setState({ PricingOnErr: 'Please select Pricing On' })
    }
    if (Name == "" || Name == null) {
        this.setState({ serviceNameErr: 'Please enter Service name' })
    }
    if (HSNCode == "" || HSNCode == null) {
        this.setState({ HSCCodeErr: 'Please enter HSN Code' })
    }
    if (GST == "" || GST == null) {
        this.setState({ GSTErr: 'Please enter GST' })
    }
    
}
  serviceDetails() {
    const { AdditionalServicesID } = this.state;
    if (AdditionalServicesID) {
      this.props
        .service_detail_action(AdditionalServicesID)
        .then((data) => {
          console.log("event details--------", data);
          if (data.error !== 1) {
            this.setState({
              Name: data.data[0]["Name"],
              Code: data.data[0]["Code"],
              PricingOn: data.data[0]["PricingOn"],
              HSNCode: data.data[0]["HSNCode"],
              GST: data.data[0]["GST"],
              StatusID: data.data[0]["StatusID"],
              ServiceAccount: data.data[0]["ServiceAccount"],
              Description: data.data[0]["Description"],
            });
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.data, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  handleSubmit() {
    var {
      AdditionalServicesID,
      Name,
      Code,
      PricingOn,
      HSNCode,
      GST,
      ServiceAccount,
      Description,
      StatusID,
    } = this.state;
    var Code = Code ? Code : this.props.location.state.Code;
    const finalStatus = StatusID ? 1 : 0;
    console.log(finalStatus)
    setTimeout(() => {
      this.inputValidate()
  }, 100);
    if (Name === "") {
      this.setState({ isLoading: false }, () => {
        toast.error("Service Name cannot be blank", {
          position:"top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
    } else if (PricingOn === "") {
      this.setState({ isLoading: false }, () => {
        toast.error("Please select Pricing On", {
          position:"top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
    } else if (HSNCode === "") {
      this.setState({ isLoading: false }, () => {
        toast.error("HSN Code cannot be blank", {
          position:"top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
    } else if (GST === "") {
      this.setState({ isLoading: false }, () => {
        toast.error("GST cannot be blank", {
          position:"top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
    } else {
      this.setState({ isLoading: true });
      // Update operation
      this.props
        .service_add_action(
          AdditionalServicesID,
          Code,
          Name,
          PricingOn,
          HSNCode,
          GST,
          ServiceAccount,
          Description,
          finalStatus
        )
        .then((data) => {
          console.log(data, "update");
          if (data.error !== 1) {
            this.setState({ isLoading: false }, () => {
              toast.success(
                AdditionalServicesID
                  ? "Service Updated Successfully"
                  : "Service Added Successfully",
                {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                }
              );
              setTimeout(() => {
                this.props.navigate("/additional_service");
              }, 1000); // Adjust the delay time as needed
            });
          } 
          else {
            console.log("else case");
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            this.setState({ isLoading: false }, () => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  
  onGst(e){
    const event = e.target.value.replace(/\D/, '');
    if (event >= 0 && event <= 100) {
      this.setState({ GST: event,GSTErr:'' })
    }else{
      this.setState({ GST: '',GSTErr:'GST value should be between 0-100' })
    }
  }

  render() {
    const { isLoading, AdditionalServicesID, StatusID,serviceNameErr,PricingOnErr,GSTErr,HSCCodeErr } =
      this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[10]} />
            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">
                    {AdditionalServicesID ? "Edit" : "Add"} Additional Services
                  </h4>
                  <div className="Service_display">
                    <h6 className="Services_Active_or_Not">{AdditionalServicesID?StatusID==1?"Active":"Inactive":"Active"}</h6>
                    <div className="checkbox checbox-switch">
                      <label className="switch">
                      {AdditionalServicesID?(
                             <>
                         
                             <input
                               type="checkbox"
                               checked={StatusID}
                               onChange={() => {
                                 this.setState((prevState) => ({
                                   StatusID: !prevState.StatusID,
                                 }));
                               }}
                             />
                             <span class="slider round"></span>
                             </>

                        ):(
                          <>
                          <input
                                                    type="checkbox"
                                                    checked={1}
                                                   
                                                  />
                                                  <span class="slider round"></span></>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="card Service_fields">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Service Code</label>
                          <input
                            type="text"
                            className="form-control search_form_control"
                            defaultValue="C001"
                            placeholder="Enter Service Code"
                            value={
                              this.state.Code
                                ? this.state.Code
                                : this.props.location.state.Code
                            }
                            disabled
                            // onChange={(e) =>
                            //   this.setState({ Code: e.target.value })
                            // }
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Service Name<span className="mendatory_class">*</span></label>
                          <input
                            type="text"
                            className="form-control search_form_control"
                            placeholder="Enter Service Name"
                            maxLength={100}
                            value={this.state.Name}
                            onChange={(e) =>
                              this.setState({ Name: e.target.value,serviceNameErr:'' })
                            }
                          />{<span className='text-danger text-start text-left d-block mt-1'>{serviceNameErr}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Pricing on<span className="mendatory_class">*</span></label>
                          <select
                            className="form-control search_form_control"
                            value={this.state.PricingOn}
                            onChange={(e) =>
                              this.setState({ PricingOn: e.target.value ,PricingOnErr:''})
                            }
                          >
                            <option value="">Select</option>
                            <option value="Per Quantity">Per Quantity</option>
                            <option value="Single Value">Single Value</option>
                          </select>{<span className='text-danger text-start text-left d-block mt-1'>{PricingOnErr}</span>}
                        </div>
                        {console.log(this.state.PricingOn)}
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>HSN Code<span className="mendatory_class">*</span></label>
                          <input
                            type="text"
                            maxLength={10}
                            className="form-control search_form_control"
                            placeholder="Enter"
                            value={this.state.HSNCode}
                            onChange={(e) =>
                              this.setState({ HSNCode: e.target.value,HSCCodeErr:'' })
                            }
                          />{<span className='text-danger text-start text-left d-block mt-1'>{HSCCodeErr}</span>}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>GST %<span className="mendatory_class">*</span></label>
                          <input
                            type="text"
                            className="form-control search_form_control"
                            placeholder="Enter"
                            value={this.state.GST}
                            onChange={(e) => this.onGst(e)}
                          />{<span className='text-danger text-start text-left d-block mt-1'>{GSTErr}</span>}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Service Account</label>
                          <select
                            className="form-control search_form_control"
                            value={this.state.ServiceAccount}
                            onChange={(e) =>
                              this.setState({ ServiceAccount: e.target.value })
                            }
                          >
                            <option>Service Account1</option>
                            <option>Service Account2</option>
                          </select>
                        </div>
                      </div>
                    </div>
                   
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Description</label>
                          <textarea
                            className="form-control"
                            rows={3}
                            placeholder="Description here.."
                            defaultValue={""}
                            value={this.state.Description}
                            onChange={(e) =>
                              this.setState({ Description: e.target.value })
                            }
                          />
                          {/* <input type="text" class="form-control search_form_control" placeholder="Description here.." /> */}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div class="p-2 mt-3 mb-3">
                        <a
                          href="javascript:void(0);"
                          onClick={this.handleSubmit}
                          className="btn save_btn"
                        >
                          {AdditionalServicesID ? "Update" : "Save"}
                        </a>
                      </div>
                      {/* <a href="Services.html" className="btn replicate_btn">
                          Replicate
                        </a> */}
                      <div class="p-2 mt-3 mb-3">
                        <a
                          href="javascript:void(0);"
                          onClick={() => this.navigateBackService()}
                          className="btn back_btn"
                        >
                          Back
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, { service_add_action, service_detail_action })(ServicesAdd)
);
